import axios from 'axios';
import { getBaseURL } from './getBaseUrl';

const BASE_URL = getBaseURL();

export const axiosPublic = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
